import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, UrlTree } from '@angular/router';
import { first } from 'rxjs/operators';
import { UserService } from '@lsq-frontend/angular-shared/features/user-service';

@Injectable()
export class NotAuthorizedGuard implements CanActivate {
    constructor(private _userService: UserService) {}

    public async canActivate(routeSnapshot: ActivatedRouteSnapshot): Promise<boolean | UrlTree> {
        const isLoggedIn = await this._userService.isLoggedIn$.pipe(first()).toPromise();

        const canActivate =
            !isLoggedIn ||
            (!!routeSnapshot.data &&
                !!routeSnapshot.data.guardBypassQueryParams &&
                routeSnapshot.data.guardBypassQueryParams.some((queryParam: string) =>
                    routeSnapshot.queryParamMap.has(queryParam)
                ));

        if (!canActivate) {
            this._userService.navigateToHome();
        }
        return canActivate;
    }
}
